/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const Countries = {
        AUSTRIA: 'at',
        AUSTRALIA: 'au',
        AZERBAIJAN: 'az',
        BELGIUM: 'be',
        BULGARIA: 'bg',
        CROATIA: 'hr',
        CYPRUS: 'cy',
        CZECH_REPUBLIC: 'cz',
        DENMARK: 'dk',
        ESTONIA: 'ee',
        FINLAND: 'fi',
        FRANCE: 'fr',
        GERMANY: 'de',
        GEORGIA: 'ge',
        GHANA: 'gh',
        GREECE: 'gr',
        HUNGARY: 'hu',
        IRELAND: 'ie',
        ITALY: 'it',
        KAZAKHSTAN: 'kz',
        KENYA: 'ke',
        LATVIA: 'lv',
        LITHUANIA: 'lt',
        LUXEMBOURG: 'lu',
        MALTA: 'mt',
        MEXICO: 'mx',
        NETHERLANDS: 'nl',
        NEW_ZEALAND: 'nz',
        NIGERIA: 'ng',
        NORWAY: 'no',
        POLAND: 'pl',
        PORTUGAL: 'pt',
        ROMANIA: 'ro',
        RUSSIA: 'ru',
        SLOVAKIA: 'sk',
        SLOVENIA: 'si',
        SPAIN: 'es',
        SWEDEN: 'se',
        TUNISIA: 'tn',
        UNITED_KINGDOM: 'gb',
        UKRAINE: 'ua',
        BELARUS: 'by',
        SOUTH_AFRICA: 'za',
        ARMENIA: 'am',
        TANZANIA: 'tz'
} as const;
export type Countries = typeof Countries[keyof typeof Countries];

